module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Titel","data":"Daten","cancel":"abbrechen","save":"speichern","name":"Name"},"en":{"title":"Title","data":"Data","cancel":"cancel","save":"save","name":"Name"}}')
  delete Component.options._Ctor
}
